import AclName from '../acl/AclName';
import model from '../models-v2/amqp/queue';

export default [
  {
    path: '/amqp-queues',
    name: 'amqp-queues',
    components: {
      default: () => import('../pages/data-grid.vue'),
      topRightSection: () => import('../components-v2/top-right-section.vue'),
    },
    meta: {
      acl: AclName.AmqpQueuesList,
      breadcrumb: [
        { title: 'Admin', url: '' },
        { title: 'Stan kolejek', url: '/amqp-queues' },
      ],
      rule: 'editor',
      search: false,
      module: 'CRM',
    },
    props: {
      default: (props) => ({ ...props, model }),
      topRightSection: (props) => ({ ...props, actions: model.topRightActions }),
    },
  },
];
